import React, { useRef, useEffect } from "react";

export default function ParticleBackground({ enabled }) {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;
    const density = window.innerWidth < 768 ? 60 : 140;
    const particles = Array.from({ length: density }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      r: Math.random() * 1.4 + 0.4,
      vx: (Math.random() - 0.5) * 0.15,
      vy: (Math.random() - 0.5) * 0.15,
      alpha: Math.random() * 0.6 + 0.2,
      pulse: Math.random() * Math.PI * 2,
    }));

    const resize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };
    window.addEventListener("resize", resize);

    const draw = () => {
      ctx.clearRect(0, 0, width, height);
      // Radial vignette gradient
      const grad = ctx.createRadialGradient(width / 2, height / 2, 0, width / 2, height / 2, Math.max(width, height) / 1.2);
      grad.addColorStop(0, "rgba(212,175,55,0.03)");
      grad.addColorStop(1, "rgba(5,5,5,0)");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, width, height);

      const now = performance.now() * 0.001;
      particles.forEach((p) => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = width; if (p.x > width) p.x = 0;
        if (p.y < 0) p.y = height; if (p.y > height) p.y = 0;
        const pulse = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin(now * 1.3 + p.pulse));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(212,175,55,${(p.alpha * pulse).toFixed(3)})`;
        ctx.shadowColor = "rgba(212,175,55,0.6)";
        ctx.shadowBlur = 8;
        ctx.fill();
        ctx.shadowBlur = 0;
      });
      rafRef.current = requestAnimationFrame(draw);
    };
    rafRef.current = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener("resize", resize);
    };
  }, [enabled]);

  if (!enabled) {
    return (
      <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 0 }} data-testid="particle-bg-off">
        <div className="absolute inset-0" style={{
          background: "radial-gradient(ellipse at 20% 30%, rgba(212,175,55,0.08), transparent 55%), radial-gradient(ellipse at 80% 70%, rgba(139,0,0,0.08), transparent 55%)"
        }}/>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 0 }} data-testid="particle-bg-on">
      <canvas ref={canvasRef} className="w-full h-full" />
      <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse at center, transparent 30%, rgba(0,0,0,0.6) 100%)"
      }}/>
    </div>
  );
}
